var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal-page",
    {
      attrs: {
        heading: _vm.hasResetEmailBeenSent
          ? "Reset password email sent"
          : "Forgot your password?"
      }
    },
    [
      _c(
        "article",
        [
          _vm.hasResetEmailBeenSent
            ? [
                _c("p", { staticClass: "intro" }, [
                  _vm._v("Please check your inbox.")
                ])
              ]
            : [
                _c("p", { staticClass: "intro" }, [
                  _vm._v(
                    "Enter your email and we'll send you reset instructions."
                  )
                ]),
                _vm._v(" "),
                _c(
                  "form",
                  {
                    staticClass: "form grid",
                    attrs: { novalidate: "" },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.submit($event)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "grid__row" }, [
                      _c("div", { staticClass: "grid__col grid__col--100" }, [
                        _c(
                          "label",
                          {
                            staticClass: "reader-only",
                            attrs: { for: "ForgotPasswordEmail" }
                          },
                          [_vm._v("Email Address")]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.email,
                              expression: "email",
                              modifiers: { trim: true }
                            },
                            {
                              name: "validate",
                              rawName: "v-validate.disable",
                              value: "required|email",
                              expression: "'required|email'",
                              modifiers: { disable: true }
                            }
                          ],
                          class: {
                            "input--invalid": _vm.errors.has(
                              "ForgotPasswordEmail"
                            )
                          },
                          attrs: {
                            id: "ForgotPasswordEmail",
                            name: "ForgotPasswordEmail",
                            placeholder: "Email Address",
                            type: "text"
                          },
                          domProps: { value: _vm.email },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.email = $event.target.value.trim()
                            },
                            blur: function($event) {
                              _vm.$forceUpdate()
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.errors.has("ForgotPasswordEmail")
                          ? _c("span", { staticClass: "error-message" }, [
                              _vm._v(
                                _vm._s(_vm.errors.first("ForgotPasswordEmail"))
                              )
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "grid__row" }, [
                      _c("div", { staticClass: "grid__col grid__col--100" }, [
                        _c(
                          "button",
                          {
                            staticClass: "submit",
                            attrs: {
                              type: "submit",
                              disabled: _vm.isSubmitting
                            }
                          },
                          [_vm._v("Send Reset Link")]
                        )
                      ])
                    ])
                  ]
                )
              ]
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }